export const approvalStatuses = [
  { label: "Draft", value: "draft" },
  { label: "In Progress", value: "in_progress" },
  { label: "Approved", value: "approved" },
];

export const workOderApprovalStatuses = [
  { label: "Draft", value: "draft" },
  { label: "Work Can Start", value: "work_can_start" },
  { label: "Ready for Creative Review", value: "ready_for_creative_review" },
  { label: "Approved", value: "approved" },
];

export const mergedApprovalStatuses = [...approvalStatuses, ...workOderApprovalStatuses];
